import type { RotasDoModulo } from '@/app/rotas';

import { DocumentsPage } from './DocumentsPage';

/** Repositorio de documentos. */
export const rotas: RotasDoModulo = {
  menu: { '/documentos': DocumentsPage },
};
